import { CapaPurchaseOrderModel } from '@generated/graphql';
import { makeStyles } from '@material-ui/styles';
import { EmptyCard } from './EmptyCard';
import { PaymentItemCard } from './PaymentItemCard';
import ReviewWriteDialog from '@components/Dialog/Review/ReviewWriteDialog';
interface ManufactureHistoryListProps {
  list: CapaPurchaseOrderModel[];
}

const ManufactureHistoryList = ({ list }: ManufactureHistoryListProps) => {
  const { manufactureHistoryListContainer } = useStyles();
  const listLength = list.length;

  if (!listLength) {
    return <EmptyCard />;
  }

  return (
    <div className={manufactureHistoryListContainer}>
      {list
        .filter((item) => item.paymentManageModelList?.[0])
        .map((props, index) => (
          <PaymentItemCard key={props.purchaseOrderId} {...props} />
        ))}

      <ReviewWriteDialog />
    </div>
  );
};

export default ManufactureHistoryList;

const useStyles = makeStyles({
  manufactureHistoryListContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  }
});
